export default "/_next/static/chunks/fonts/Syne SemiBold-a85e1a91be6d9b17d84e8a93e6053db8.ttf";